// Vendor
import $ from "jquery";
import axios from "axios";
import balanceText from "../libs/BalanceText";
import Helpers from "../helpers/util";

// Elements
let $el = $("body.menu-listing");
class MenuListing {
    constructor($el) {
        this.$el = $el;
        this.$ajaxLinks = this.$el.find(".sub-nav a");
        this.$ajaxLoader = this.$el.find(".ajax-page-loader");
        this.fetching = false;

        this.attachHandlers();
    }

    attachHandlers() {
        this.$ajaxLinks
            .on("click", (event) => {
                event.preventDefault();
                let shiftAmount = Math.abs(this.linkDownX - this.linkUpX);
                if (!this.fetching && shiftAmount < 10) {
                    // update sub nav active classes
                    this.$ajaxLinks.removeClass("active");
                    $(event.currentTarget).addClass("active");

                    // ajax href
                    this.ajaxPage($(event.currentTarget).attr("href"));
                }
            })
            .on("mousedown", (event) => {
                this.linkDownX = event.pageX;
            })
            .on("mouseup", (event) => {
                this.linkUpX = event.pageX;
            })
            .on("touchstart", (event) => {
                this.linkDownX = event.pageX;
            })
            .on("touchend", (event) => {
                this.linkUpX = event.originalEvent.changedTouches[0].pageX;
            });
    }

    ajaxPage(url) {
        this.fetching = true;

        // fade out page
        this.$oldPage = this.$el.find(".ajax-page.current-page");
        this.$oldPage.removeClass("current-page fadeInUpSmall");
        this.$oldPage.addClass("old-page animated fadeOutDownSmall");

        // show loader
        this.$ajaxLoader.fadeIn();

        // axios request to new html page
        const requestStartTime = new Date();
        axios
            .get(url)
            .then((response) => {
                // hide loader
                this.$ajaxLoader.fadeOut();

                // update html5 browser history state
                let newTitle = $(response.data).filter("title").text();
                document.title = newTitle;
                window.history.replaceState(
                    { html: response.data, pageTitle: newTitle },
                    "",
                    url
                );

                // calculate delay
                const ms = new Date() - requestStartTime.getTime();

                setTimeout(() => {
                    // set new page
                    this.newPage(response.data);

                    // finished loading page
                    this.fetching = false;
                }, 1000 - ms);
            })
            .catch((error) => {
                console.log(error);

                // finished loading page
                this.fetching = false;
            });
    }

    newPage(htmlString) {
        // Create a single structured node containing all the new HTML
        const $newHTML = $("<div></div>").append($.parseHTML(htmlString));

        // get new page from html document string
        const $el = $newHTML.find(".ajax-page");
        const newPage = $el.addClass("animated fadeInUpSmall");

        Helpers.dom.onAnimationEnd($el, () => {
            $el.removeClass("animated fadeInUpSmall");
        });

        // add new page
        this.$oldPage.before(newPage[0]);

        // remove old page from DOM
        this.$oldPage.remove();

        // call balance text on new hero heading
        const $newHeading = $(".current-page .h-underline");
        balanceText($newHeading, {
            watch: true,
        });
        $newHeading.addClass("in-viewport animated");

        // Find the new footer banner
        let newCenteredBGOverlay = $newHTML
            .find(".centered-bg-overlay")
            .addClass("animated fadeInUpSmall");

        // If we find one, replace the current one with it
        if (newCenteredBGOverlay.length) {
            const oldBanner = $(".centered-bg-overlay");
            oldBanner.before(newCenteredBGOverlay);
            oldBanner.remove();
        }
    }
}

const _init = () => {
    if ($el.length) {
        new MenuListing($el);
    }
};

_init();
